import { Module } from "vuex"
import { RangeState } from "@/types/tikuInterface"

export const Range: Module<RangeState, unknown> = {
  namespaced: true,

  state: () => ({
    startId: null,
    endId: null,
  }),

  mutations: {
    setStartId(state, startId: number) {
      state.startId = startId;
    },
    clearStartId(state) {
      state.startId = null;
    },
    setEndId(state, endId: number) {
      state.endId = endId;
    },
    clearEndId(state) {
      state.endId = null;
    },
    setIdRange(state, { startId, endId }: { startId: number; endId: number }) {
      state.startId = startId
      state.endId = endId
    },

    clearIdRange(state) {
      state.startId = null
      state.endId = null
      localStorage.removeItem("id-range-store")
    },

    loadIdRange(state) {
      const data = localStorage.getItem("id-range-store")
      if (data) {
        const { startId, endId } = JSON.parse(data)
        state.startId = startId
        state.endId = endId
      }
    },
  },

  actions: {
    updateIdRange(
      { commit },
      { startId, endId }: { startId: number; endId: number }
    ) {
      commit("setStartId", startId)
      commit("setEndId", endId)
      localStorage.setItem(
        "id-range-store",
        JSON.stringify({ startId, endId })
      )
    },

    initIdRange({ commit }) {
      commit("loadIdRange")
    },

    resetIdRange({ commit }) {
      commit("clearIdRange")
    },
  },

  getters: {
    getStartId(state): number | null {
      return state.startId
    },
    getEndId(state): number | null {
      return state.endId
    },
    getIdRange(state): { startId: number | null; endId: number | null } {
      return { startId: state.startId, endId: state.endId }
    },
    hasIdRange(state): boolean {
      return state.startId !== null && state.endId !== null
    },
  },
}
